<script setup lang="ts">
import { computed } from 'vue';
import { loadErrorMessages } from '../../messages';
import { errorDetail } from './errorDetail';

const props = withDefaults(
  defineProps<{
    error?: Error | string | null;
    reloading?: boolean;
  }>(),
  {
    error: null,
    reloading: false,
  },
);

const emit = defineEmits<{
  (e: 'reload'): void;
}>();

const detail = computed(() => errorDetail(props.error));
</script>

<template>
  <div
    class="itp-load-error d-flex flex-column align-items-center justify-content-center text-center p-4"
    role="alert"
  >
    <p class="itp-load-error__title fw-semibold mb-1">{{ loadErrorMessages.failedToLoad }}</p>
    <p v-if="detail" class="itp-load-error__detail text-danger small mb-3">
      {{ detail }}
    </p>
    <ItpButton
      variant="primary"
      :spinning="reloading"
      :disabled="reloading"
      @click="emit('reload')"
    >
      {{ loadErrorMessages.reload }}
    </ItpButton>
  </div>
</template>

<style scoped>
.itp-load-error__detail {
  max-width: 40rem;
  word-break: break-word;
}
</style>
